import $ from 'jquery';
import _ from 'lodash';
import { onAddImageToCanvas } from '~src/image';
import { getState } from '~src/state';
import { EdgeResizer } from '~src/utils';
import { getUser, isLoggedUserGlobalEditor } from '~src/user';
import { onAddMagicFrameToCanvas } from '~core/magicFrame';
import editorConfig from '~config/editorConfig';
import differenceInDays from 'date-fns/differenceInDays';

const hasTagMagicFrame = (tags = []) =>
  tags.some((tag) => tag.name === editorConfig.magicFrameTag);

const htmlImages = async (sidebarImages) => {
  const { user } = await getUser();
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const { items, html } = sidebarImages.reduce(
    (acc, item) => {
      let previewImg = new EdgeResizer(item.file.url).scaleToWidth(250);
      if (item.custom_preview) {
        previewImg = new EdgeResizer(item.custom_preview.url).scaleToWidth(250);
      } else {
        previewImg = new EdgeResizer(item.file.url).scaleToWidth(250);
      }

      const itemId = `editor-sidebar-add-canvas-image-${item.objectId}`;

      let buttons = `<div class="option-button-container sidebar-context-menu-trigger bg-color-existing-canvas">
                      <div class="option-button-container-relative">
                        <div class="context-menu context-menu-child sidebar-context-menu bg-color-existing-canvas color-existing-canvas">
                          <div class="item context-menu-child"
                            data-images-item-id="${item.objectId}"
                            data-tab-target="tab-images-tag">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="sidebar-context-menu__icon">
                              <path stroke-linecap="round" stroke-linejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                            </svg>
                            Dettagli
                          </div>`;

      if (item.org_pointer || isGlobalEditor) {
        if (
          user.org_pointer.objectId === item.org_pointer?.objectId ||
          isGlobalEditor
        ) {
          buttons += `
                          <div class="item context-menu-child item--danger" data-delete-images-id="${item.objectId}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                              <path fill="currentColor" d="M8 5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3h4.25a.75.75 0 1 1 0 1.5H19V18a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6.5H3.75a.75.75 0 0 1 0-1.5H8zM6.5 6.5V18c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V6.5h-11zm3-1.5h5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5zm-.25 4h1.5v8h-1.5V9zm4 0h1.5v8h-1.5V9z"></path>
                            </svg>
                            Elimina
                          </div>`;
        }
      }

      buttons += `
                        </div>
                      </div>
                    </div>`;

      acc.html += '<div class="sidebar-item-grid-box image-square-container">';

      if (
        differenceInDays(new Date(), new Date(item.createdAt)) <= 30 &&
        item.isGlobal === true
      ) {
        acc.html += '<div class="sidebar-badge-new">Novità</div>';
      }

      acc.html += `<div id="${itemId}" data-url="${
        item.file.url
      }" data-width="${item.width}" data-height="${
        item.height
      }" data-svg-clip="${_.get(
        item,
        'svgClip.url',
        ''
      )}" class="sidebar-item-grid-box-click-listener"></div>
                          <img
                              src="../assets/svg/img-loader.gif"
                              class="lazy image-square"
                              data-src="${previewImg}"
                          />
                      ${buttons}
                    </div>`;

      const element = {
        id: `#${itemId}`,
      };

      if (hasTagMagicFrame(item.tags)) {
        element.type = 'magic-frame';
      } else {
        element.type = 'image';
      }

      acc.items.push(element);

      return acc;
    },
    { items: [], html: '' }
  );

  if (items.length) {
    items.forEach((item) => {
      $('body').off(
        'click',
        item.id,
        item.type === 'magic-frame'
          ? onAddMagicFrameToCanvas
          : onAddImageToCanvas
      );
      $('body').on(
        'click',
        item.id,
        item.type === 'magic-frame'
          ? onAddMagicFrameToCanvas
          : onAddImageToCanvas
      );
    });
  }
  return html;
};

const templateAddImagesDefault = async (images) => {
  const imagesDefault = images.filter((images) => images.isGlobal === true);

  let html;

  if (imagesDefault.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non ci sono sfondi disponibili</div></div>';
  } else {
    html = await htmlImages(imagesDefault);
  }

  $('#editor-sidebar-images').html(html);
};

const templateAddImagessCustom = async (images) => {
  const { user } = await getUser();

  const imagesCustom = images.filter(
    (images) =>
      images.org_pointer &&
      images.org_pointer.objectId === user.org_pointer.objectId
  );

  let html;

  if (imagesCustom.length === 0) {
    html =
      '<div class="containerTextEmptyBox"><div class="textEmptyBox">Non hai caricato immagini personalizzate</div></div>';
  } else {
    html = await htmlImages(imagesCustom);
  }

  $('#editor-sidebar-images-custom').html(html);
};

export const displaySidebarImages = async () => {
  const currentTag = getState('sidebarCurrentImagesTag', 'NO_TAG');

  const sidebarImages = _.get(
    window.editorConfig,
    `sidebarImages[${currentTag}]`,
    { items: [] }
  );

  await Promise.all([
    templateAddImagesDefault(sidebarImages.items),
    templateAddImagessCustom(sidebarImages.items),
  ]);

  window.lazyLoadInstance.update();
};
